import mitt from 'mitt'
import { PopupType } from '~/static/enums/popup'

type ApplicationEvents = {
  'popup:show': {
    type?: PopupType
    text: string
    closeAfter?: number
  }
  'editor:save': undefined
  'editor:saved': undefined
  'editor:download': undefined
  'editor:clone': undefined
  'cookies:popup': undefined
  'text:open-editor': {
    initialText: string
    callback: (text: string) => void
  }
  'full-panel:open': {
    title: string
    showBackButton: boolean
    showCloseButton: boolean
    fullSize: boolean
  }
  'full-panel:close': undefined
}

export default defineNuxtPlugin(() => {
  const emitter = mitt<ApplicationEvents>()

  return {
    provide: {
      event: emitter.emit,
      listen: emitter.on,
      off: emitter.off,
    },
  }
})
